import { DatePicker, Typography } from "antd";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React from "react";
import { EXPIRY_TYPE } from "../requirements/constants";
const { Text } = Typography;

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'expiries' implicitly has an 'any' type.
const expiry = ({ expiries, handleChange, selectedRowKeys }) =>
  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter '_' implicitly has an 'any' type.
  function (_, record) {
    const isSelected = selectedRowKeys.includes(record._id);
    const isRequirementNonExpiring = record?.expiryType === EXPIRY_TYPE.DOES_NOT_EXPIRE;

    return isRequirementNonExpiring ? (
      <Text>Does not expire</Text>
    ) : (
      <DatePicker
        disabled={!isSelected}
        onChange={handleChange(record._id)}
        value={expiries[record._id]}
      />
    );
  };

export { expiry };
